import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { pad2 } from 'utils/string'

const Score = styled.div<TSFixMe>`
  color: #1976d2;
  white-space: nowrap;
`

const CheckInScore = ({ checkInScore }: TSFixMe): TSFixMe => {
  if (checkInScore === null || checkInScore === undefined) return null

  const displayedScore = pad2(Math.floor(checkInScore * 100))

  return (
    <Score>
      <FormattedMessage
        id="bookingTrip.checkInScore.value"
        defaultMessage="CheckIn score: {checkInScore}"
        values={{
          checkInScore: displayedScore
        }}
      />
    </Score>
  )
}

CheckInScore.propTypes = {
  checkInScore: PropTypes.number
}

export { CheckInScore }
